export default "__VITE_ASSET__2ef65406__"